import React, { useState } from "react";
import { Formik } from "formik";

const initialValues = {
  name: "",
  state_code: "",
  status: "",
  country: "",
  countryname:""
};

export function StateFilter({ filterValues, countryList, myRef }) {
  const applyFilter = (values) => {
    filterValues(values);
  };
  const [stateFilter, setStateFilter] = useState(initialValues);
  return (
    <>
      <Formik
        initialValues={
          stateFilter
        }
        onSubmit={(values) => {
          applyFilter(values);
        }}
        onReset={values => {
          console.log("Hello shankar", values);
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
          handleReset,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="countryname"
                  onChange={(e) => {
                    setFieldValue("countryname", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.countryname}
                >
                  <option value="">All</option>
                  {countryList.map((country, index) => (
                    <option value={country.id} key={index}>
                      {country.name}
                    </option>
                  ))}
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Country</b>
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="status"
                  placeholder="Filter by status Type"
                  onChange={(e) => {
                    setFieldValue("status", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.status}
                >
                  <option value="">All</option>
                  <option value="1"> Active</option>
                  <option value="0">Deactive</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Status</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="State"
                  onBlur={handleBlur}
                  value={values.name}
                  onChange={(e) => {
                    setFieldValue("name", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>State</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="state_code"
                  placeholder="State code"
                  onBlur={handleBlur}
                  value={values.state_code}
                  onChange={(e) => {
                    setFieldValue("state_code", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>State code</b>
                </small>
              </div>
              <div className="col-lg-2">
                <button
                  className="btn btn-white-primary"
                  onClick={handleReset}
                  ref={myRef}
                  style={{ display: "none" }}
                ></button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
